<template>
<div class="main-container">
  <div>
    <tl-header type="h1">Salary Bands</tl-header>
    <div v-if="showIntro && bandsData.length==0" class="row-container center">
      <div class="company-info">
        <br><img class="image" src="@/assets/bands.svg" />
        <!-- <div @click="goToBandsPage"><img class="closeImage" src="@/assets/close.png" /></div> -->
        <div class="fontStyle">
          <br><br><span>Salary banding is the range of pay established by
            organisations to pay employees performing a particular job
            or function.</span><br><br>
          <span>Salary banding defines the market and internal value
            for each role and provides an effective way to manage
            employee pay.</span>
          <div class="divider"></div><br><br>
          <btn text="Get Started" type="secondary" @click="goToBandsPage" />
        </div>
      </div>
    </div>
    <bottom-action-container class="placeAtEnd">
      <btn-skip @navClicked="skip"></btn-skip>
    </bottom-action-container>
  </div>
  <div v-if="!showIntro || bandsData.length!=0">
    <bands @displayIntro="goToIntro" />
  </div>
  <!-- <div v-else>
    <band-stepper @displayIntro="goToIntro" />
  </div> -->
</div>
</template>
<script>
// import BandStepper from "./Bandstepper.vue";
import Bands from "./Bands.vue";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "BandsIntro",
  components: {
    // BandStepper,
    Bands
  },
  computed: {
    ...mapState("onboard/salary_bands", {
      bandsData: state => state.data
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else {
          return this.getleid(0);
      }
    }
  },
  data() {
    return {
      showIntro: true
    };
  },

  activated: function() {
      this.fetchBands(this.leId);
  },
  methods: {
    ...mapActions("onboard/salary_bands/", {
      fetch: "fetchAll",
      act_enable: "enable"
    }),
    navHandler(navType) {
      this.$validator.reset();
      if (navType == "back") {
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/grades`
        });
      }
      if (navType == "next") {
        this.$validator.reset();
        this.$router.push({
          path: `/onboarding/entity/${
            this.$route.params.entity_index
          }/statutory`
        });
      }
    },
    goToIntro() {
      this.showIntro = true;
    },
    goToBandsPage() {
      this.showIntro = false;
    },
    async fetchBands() {
      try {
        await this.fetch(this.leId);
      } catch (err) {
        //console.log(err);
      }
    },
    skip() {
      this.$router.push(`/onboarding/entity/${this.$route.params.entity_index}/grades`)
    }

  }
};
</script>

<style lang="scss" scoped>
.row-container {
  .value {
    margin-right: 0;
  }
}

.image {
  margin-top: 30px;
}

.company-info {
  display: flex;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  align-items: flex-start;
  position: relative;
  width: 100%;
}

.closeImage {
  position: absolute;
  float: right;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.building {
  width: 56px;
  height: 58px;
  object-fit: contain;
  margin: 25px 0 0 129px;
}

.fontStyle {
  margin-left: 20px;
  font-family: Montserrat;
  font-size: 16px;
  color: #404040;
}

.divider {
  color: #34c0be;
  border-bottom: 2px solid #34c0be;
  width: 60%;
  margin: 30px 0 0 5px;
}

.placeAtEnd {
  margin-top: 200px;
}
</style>
